const clickAudio = new Audio(require("../assets/click.wav"));

export function playClickSound() {
  clickAudio.currentTime = 0;
  clickAudio.play();
}
